import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { ExpandMore, Delete } from '@material-ui/icons';
import {
  especieList,
  categoriaList,
  simNaoNaoInformado,
  danificadoList,
  aluguelList,
  veiculosList,
} from '../../utils/objectsSelect';
import { formStyles } from './styles';
import AccordionDeleteWarn from '../AccordionDeleteWarn';
import { VehicleObject } from '../../@types/incidentTypes';

interface IProps {
  vehicleObject: VehicleObject;
  deleteVehicle: (index: number) => void;
  changeVehiclesState: (vehicle: VehicleObject) => void;
  viaNames: string[];
  desabilitadoVehicleForm?: boolean;
}

const VehicleForm: React.FC<IProps> = ({
  vehicleObject,
  deleteVehicle,
  changeVehiclesState,
  viaNames,
  desabilitadoVehicleForm,
}) => {
  const [vehicleState, setVehicleState] = useState<VehicleObject>(vehicleObject);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const classes = formStyles();

  const handleChange = (key: string, value: string) => {
    setVehicleState({ ...vehicleState, [key]: value });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenWarn(!openWarn);
  };

  useEffect(() => {
    setVehicleState((prev) => {
      return {
        ...prev,
        // 'Código Veículo': vehicleObject['Código Veículo'],
        // index: vehicleObject.index,
        ...vehicleObject
      };
    });
  }, [vehicleObject]);

  return (
    <div className={classes.accordionRow}>
      <Accordion style={{ marginRight: 10, marginBottom: 15 }}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>{`Veículo ${vehicleState.index + 1}`}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVeiculo[${vehicleState.index}].Tipo Veículo`}
                className={classes.label}
              >
                Tipo Veículo
              </InputLabel>

              <Select
                variant="outlined"
                value={vehicleState['Tipo Veículo']}
                onChange={(event) => {
                  handleChange('Tipo Veículo', event.target.value as string);
                }}
                onBlur={() => changeVehiclesState(vehicleState)}
                className={classes.select}
                disabled={desabilitadoVehicleForm}
              >
                {veiculosList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Placa`}
                  className={classes.label}
                >
                  Placa
                </InputLabel>
                <input
                  name="Placa"
                  id={`data.driverVeiculo[${vehicleState.index}].Placa`}
                  className={classes.input}
                  onChange={(event) => {
                    const valor = event.target.value.replace(
                      /[^((0-9)|(a-z)|(A-Z)|\s)]/g,
                      '',
                    );
                    handleChange('Placa', valor);
                  }}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState.Placa}
                  maxLength={7}
                  placeholder="Placa do veículo"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Marca`}
                  className={classes.label}
                >
                  Marca
                </InputLabel>
                <input
                  name="Marca"
                  id={`data.driverVeiculo[${vehicleState.index}].Marca`}
                  className={classes.input}
                  onChange={(event) => handleChange('Marca', event.target.value)}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState.Marca}
                  placeholder="Marca do veículo"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Ano Fabricação`}
                  className={classes.label}
                >
                  Ano Fabricação
                </InputLabel>
                <input
                  name="Ano Fabricação"
                  id={`data.driverVeiculo[${vehicleState.index}].Ano Fabricação`}
                  className={classes.input}
                  onChange={(event) => handleChange('Ano Fabricação', event.target.value)}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState['Ano Fabricação']}
                  placeholder="Ano Fabricação"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Cor`}
                  className={classes.label}
                >
                  Cor
                </InputLabel>
                <input
                  name="Cor"
                  id={`data.driverVeiculo[${vehicleState.index}].Cor`}
                  className={classes.input}
                  onChange={(event) => handleChange('Cor', event.target.value)}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState.Cor}
                  placeholder="Cor"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVeiculo[${vehicleState.index}].Espécie`}
                className={classes.label}
              >
                Espécie
              </InputLabel>

              <Select
                variant="outlined"
                value={vehicleState.Espécie}
                onChange={(event) => {
                  handleChange('Espécie', event.target.value as string);
                }}
                onBlur={() => changeVehiclesState(vehicleState)}
                className={classes.select}
                disabled={desabilitadoVehicleForm}
              >
                {especieList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVeiculo[${vehicleState.index}].Categoria`}
                className={classes.label}
              >
                Categoria
              </InputLabel>

              <Select
                variant="outlined"
                value={vehicleState.Categoria}
                onChange={(event) => {
                  handleChange('Categoria', event.target.value as string);
                }}
                onBlur={() => changeVehiclesState(vehicleState)}
                className={classes.select}
                disabled={desabilitadoVehicleForm}
              >
                {categoriaList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVeiculo[${vehicleState.index}].Aluguel`}
                className={classes.label}
              >
                Aluguel
              </InputLabel>
              <Select
                variant="outlined"
                value={vehicleState.Aluguel}
                onChange={(event) => {
                  handleChange('Aluguel', event.target.value as string);
                }}
                onBlur={() => changeVehiclesState(vehicleState)}
                className={classes.select}
                disabled={desabilitadoVehicleForm}
              >
                {aluguelList.map((item) => (
                  <MenuItem value={item.label} key={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.radioInputContainer}>
                <InputLabel htmlFor="Legalizado" className={classes.radioInputLabel}>
                  Legalizado
                </InputLabel>
                <div>
                  {simNaoNaoInformado.map((item) => {
                    const checkboxId = `Legalizado-[${item.label}]`;
                    return (
                      <FormControlLabel
                        id={checkboxId}
                        key={checkboxId}
                        className={classes.formControlLabel}
                        label={<span className={classes.inputLabel}>{item.label}</span>}
                        control={
                          <input
                            name={item.label}
                            className={classes.radioInput}
                            type="checkbox"
                            checked={vehicleState.Legalizado === item.label}
                            onChange={(event) => {
                              handleChange('Legalizado', event.target.value);
                            }}
                            onBlur={() => changeVehiclesState(vehicleState)}
                            value={item.label}
                          />
                        }
                        disabled={desabilitadoVehicleForm}
                      />
                    );
                  })}
                </div>
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.radioInputContainer}>
                <InputLabel htmlFor="Danificado" className={classes.radioInputLabel}>
                  Danificado
                </InputLabel>
                <div>
                  {danificadoList.map((item) => {
                    const checkboxId = `Danificado-[${item.label}]`;
                    return (
                      <FormControlLabel
                        id={checkboxId}
                        key={checkboxId}
                        className={classes.formControlLabel}
                        label={<span className={classes.inputLabel}>{item.label}</span>}
                        control={
                          <input
                            name={item.label}
                            className={classes.radioInput}
                            type="checkbox"
                            checked={vehicleState.Danificado === item.label}
                            onChange={(event) => {
                              handleChange('Danificado', event.target.value);
                            }}
                            onBlur={() => changeVehiclesState(vehicleState)}
                            value={item.label}
                          />
                        }
                        disabled={desabilitadoVehicleForm}
                      />
                    );
                  })}
                </div>
              </div>
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <InputLabel
                htmlFor={`data.driverVeiculo[${vehicleState.index}].Via de Acesso`}
                className={classes.label}
              >
                Via de Acesso
              </InputLabel>

              <Select
                variant="outlined"
                value={vehicleState['Via de Acesso']}
                onChange={(event) => {
                  handleChange('Via de Acesso', event.target.value as string);
                }}
                onBlur={() => changeVehiclesState(vehicleState)}
                className={classes.select}
                disabled={desabilitadoVehicleForm}
              >
                {viaNames.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Manobra`}
                  className={classes.label}
                >
                  Manobra
                </InputLabel>
                <input
                  name="Manobra"
                  id={`data.driverVeiculo[${vehicleState.index}].Manobra`}
                  className={classes.input}
                  onChange={(event) => handleChange('Manobra', event.target.value)}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState.Manobra}
                  placeholder="Manobra"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Outra manobra`}
                  className={classes.label}
                >
                  Outra manobra
                </InputLabel>
                <input
                  name="Outra manobra"
                  id={`data.driverVeiculo[${vehicleState.index}].Outra manobra`}
                  className={classes.input}
                  onChange={(event) => handleChange('Outra manobra', event.target.value)}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState['Outra manobra']}
                  placeholder="Outra manobra"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Número do Ônibus`}
                  className={classes.label}
                >
                  Número do Ônibus
                </InputLabel>
                <input
                  name="Número do Ônibus"
                  id={`data.driverVeiculo[${vehicleState.index}].Número do Ônibus`}
                  className={classes.input}
                  onChange={(event) => {
                    handleChange('Número do Ônibus', event.target.value);
                  }}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState['Número do Ônibus']}
                  placeholder="Número do Ônibus"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Linha do Ônibus`}
                  className={classes.label}
                >
                  Linha do Ônibus
                </InputLabel>
                <input
                  name="Linha do Ônibus"
                  id={`data.driverVeiculo[${vehicleState.index}].Linha do Ônibus`}
                  className={classes.input}
                  onChange={(event) => {
                    handleChange('Linha do Ônibus', event.target.value);
                  }}
                  onBlur={() => changeVehiclesState(vehicleState)}
                  value={vehicleState['Linha do Ônibus']}
                  placeholder="Linha do Ônibus"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <div className={classes.inputContainer}>
                <InputLabel
                  htmlFor={`data.driverVeiculo[${vehicleState.index}].Código Veículo`}
                  className={classes.label}
                >
                  Código Veículo
                </InputLabel>
                <input
                  name="Código Veículo"
                  id={`data.driverVeiculo[${vehicleState.index}].Código Veículo`}
                  className={classes.input}
                  readOnly
                  aria-label="bit.ly/Código-veículo"
                  value={vehicleState['Código Veículo']}
                  placeholder="Código Veículo"
                  disabled={desabilitadoVehicleForm}
                />
              </div>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <IconButton
        onClick={handleClick}
        title={`Remover Veículo ${vehicleState.index + 1}`}
        disabled={desabilitadoVehicleForm}
      >
        <Delete />
      </IconButton>
      <AccordionDeleteWarn
        message={`Remover a Veículo ${vehicleState.index + 1}?`}
        open={openWarn}
        setOpen={setOpenWarn}
        index={vehicleState.index}
        anchorEl={anchorEl}
        deleteItem={() => deleteVehicle(vehicleState.index)}
      />
    </div>
  );
};

export default VehicleForm;
